module.exports = __webpack_public_path__ + "static/img/index_bottom_logo.c26a1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/index_bottom_logo.png
// module id = /i+K
// module chunks = 1